import SortedBy from './SortedBy';

export default SortedBy;
